# В этом классе описываем все, что относится к работе различных форм
class window.Form
  constructor: ->
    @initInputsInnerLabels()
    @initSelectors()
    @initSelectorsWithInputs()
    @initToggleFormContent()
    @initDataTimePicker()
    @checkDateRange()
    @initGetFilesInput()
    


  # Инициализация инпутов с лэйблом внутри их
  initInputsInnerLabels: ->
    inputWrapper = $('.base-input-wrapper--inner-label')
    activeClass = 'base-label--active'

    inputWrapper.click ->
      label = $(this).find('.base-label')
      input = $(this).find('.base-input-text')
      if input[0] != undefined
        label.addClass activeClass
        input.focus()


    inputWrapper.focusout ->
      label = $(this).find('.base-label')
      firstChild = $(this).children()[0]
      childValue = $(firstChild).val()
      if childValue.length == 0
        label.removeClass activeClass


  # Инициализация селекторов
  initSelectors: ->

    $('.base-select').each ->
      unless $(this).hasClass("base-select--with-input")
        selectWrapper = $(this).parent('.base-input-wrapper')
        $(this).selectmenu({
          appendTo: selectWrapper
          transferClasses: true
          classes: {
            "ui-selectmenu-menu": "highlight"
          }
          change: (event, ui) ->
            if $(this).hasClass("js-open-blocks-by-select")
              allTargetBlocks = $('div[data-status]')
              allTargetBlocks.find("input, select").prop("disabled", true)
              allTargetBlocks.hide();
              targetBlock = $('div[data-status="ui-id-'+ui.item.value+'"]')
              targetBlock.find("input, select").prop("disabled", false)
              targetBlock.show()
              console.log(targetBlock)
        })

  initSelectorsWithInputs: ->
    $(".base-select--with-input").each ->
      unless $(this).attr("data-select-init") == "true"
        parentContainer = $(this).parent()
        $(this).select2({
          tags: true
          dropdownParent: parentContainer
        })
        $(this).attr("data-select-init", "true")

  # Инициализация частично скрытых форм    
  initToggleFormContent: ->
    hiddenfield = $('.hidden-field');

    $('.js-base-form__button-toggle').click ->
      $('.js-base-form__button-toggle').toggleClass('base-button--turn-icon');
      hiddenfield.slideToggle()


  # Инициализация календаря  
  initDataTimePicker: ->
    $('.js-data-picker').each ->
      unless $(this).attr('data-type') == 'range'
        $(this).datepicker($.datepicker.regional["ru"]);

  # Получение даты из календаря в нужном формате
  getDate: (element) ->
    dateFormat = 'dd.mm.yy'
    try
      date = $.datepicker.parseDate(dateFormat, $(element).val());
    catch error
      date = null
    return date

  # Выбор даты в диапазоне
  checkDateRange: ->
    self = this
    $('.js-data-picker-range').each ->
      start = $(this).find('.js-data-picker--start')
      finish = $(this).find('.js-data-picker--finish')

      start.datepicker(defaultDate: '+1w', changeMonth: true, numberOfMonths: 1).on 'change', ->
        finish.datepicker('option', 'minDate', self.getDate(this))

      finish.datepicker(defaultDate: '+1w', changeMonth: true, numberOfMonths: 1).on 'change', ->
        start.datepicker('option', 'maxDate', self.getDate(this))

  # Инициализация кнопки прикрепления файлов
  initGetFilesInput: ->
    $(".form-file-input").on "change", ->
      $('.file-name').remove()
      realVal = $(this)[0].files
      $('#file_is_attached').val('true')
      i = 0
      while i < realVal.length
        $("<div class=\"file-name\">#{realVal[i].name}</div>")
          .insertBefore('.file-upload-clear-box')
        i++
      return


// WEBPACK FOOTER //
// ./assets/javascripts/app/form.coffee